import { useContext } from "react";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { Trans, useTranslation } from "react-i18next";

import { Context } from "../ContextProvider";
import { LANGUAGE } from "../type";
import rope from "../assets/images/rope.jpg";
import p1 from "../assets/images/dericum_axel.png";
import p2 from "../assets/images/rohde_daniel.png";
import p3 from "../assets/images/matthias_koenig.png";

const ContactSection = () => {
  const { t } = useTranslation();
  const { language } = useContext(Context);

  return (
    <section className="flex xl:max-h-[480px] mt-24">
      <div className="hidden lg:block w-1/2 xl:w-1/3">
        <img src={rope} alt="rope" className="h-full w-full object-cover" />
      </div>
      <div className="bg-allsafe-grey-200 px-8 py-8 md:px-8 grow">
        <h2 className="text-allsafe-blue text-4xl leading-10 font-Roboto font-bold pb-2 text-center sm:text-left">
          <Trans>{t("Jetzt kontaktieren.")}</Trans>
        </h2>
        <p className="font-Roboto text-center sm:text-left">
          <Trans>
          Gemeinsam finden wir eine Lösung zur Sicherung Ihrer Ladung.
          </Trans>
        </p>
        {language === LANGUAGE.FR ? (
          <div className="flex flex-col space-y-10 items-center sm:items-start md:flex-row md:space-x-24 md:space-y-0 mt-4">
            <div className="flex flex-col items-center sm:items-start">
              <figure className="w-48">
                <img
                  src={p1}
                  alt="Dericum Axel"
                  className="w-full object-contain scale-x-[-1] ml-8 sm:ml-0"
                />
                <figcaption className="font-Roboto font-light text-center mt-2 sm:text-left">
                Axel Dericum
                </figcaption>
              </figure>
              <div className="flex space-x-6 mt-4">
                <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                  <PhoneIcon color="#1D4376" />
                </div>
                <a
                  className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                  href="tel:+49 (0) 171 561 79 51"
                >
                  +49 (0) 171 561 79 51
                </a>
              </div>
              <div className="flex space-x-6 mt-4">
                <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                  <EnvelopeIcon color="#1D4376" />
                </div>
                <a
                  className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                  href="mailto:Andreas.Spannaus@allsafe-group.com"
                >
                  axel.dericum@allsafe-group.com
                </a>
              </div>
            </div>
            <div className="flex flex-col items-center sm:items-start">
              <figure className="w-48">
                <img
                  src={p2}
                  alt="Rohde Daniel"
                  className="w-full object-contain scale-x-[-1] ml-8 sm:ml-0"
                />
                <figcaption className="font-Roboto font-light text-center mt-2 sm:text-left">
                  Daniel Rhode
                </figcaption>
              </figure>
              <div className="flex gap-x-6 mt-4">
                <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                  <PhoneIcon color="#1D4376" />
                </div>
                <a
                  className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                  href="tel:+49 (0) 175 264 04 19"
                >
                  +49 (0) 175 264 04 19
                </a>
              </div>
              <div className="flex gap-x-6 mt-4">
                <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                  <EnvelopeIcon color="#1D4376" />
                </div>
                <a
                  className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                  href="mailto:daniel.rohde@allsafe-group.com"
                >
                  daniel.rohde@allsafe-group.com
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center sm:items-start">
            <div className="max-w-[90%] mt-4">
              <figure className="w-48">
                <img
                  src={p3}
                  alt="Matthias König"
                  className="w-full object-contain scale-x-[-1] ml-8 sm:ml-0"
                />
                <figcaption className="font-Roboto font-light text-center mt-2 sm:text-left">
                Matthias König
                </figcaption>
              </figure>
            </div>
            <div className="flex gap-x-4 mt-10">
              <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                <PhoneIcon color="#1D4376" />
              </div>
              <a
                className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                href="tel:+4977335002975"
              >
                +49 7733 5002-975
              </a>
            </div>
            <div className="flex gap-x-4 mt-4">
              <div className="w-5 h-5 2xl:w-8 2xl:h-8">
                <EnvelopeIcon color="#1D4376" />
              </div>
              <a
                className="text-base leading-6 text-allsafe-blue font-Roboto font-light cursor-pointer 2xl:text-2xl 2xl:leading-8"
                href="mailto:matthias.koenig@allsafe-group.com"
              >
                matthias.koenig@allsafe-group.com
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactSection;